import { Button, InputNumber } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import React from "react"
import { ClearableInputNumberProps } from "."
import styles from "./ClearableInputNumber.module.scss"

export const ClearableInputNumber: React.FC<ClearableInputNumberProps> = ({
  value,
  onChange,
  allowClear = true,
  ...props
}) => {
  const { t } = useTranslation()
  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation()
    onChange?.(null)
  }

  const showClearIcon = allowClear && value !== null && value !== undefined

  return (
    <div className={styles.wrapper}>
      <InputNumber<number> value={value} onChange={onChange} {...props} />
      {showClearIcon && (
        <Button type="link" onClick={handleClear}>
          {t("general.clear")}
        </Button>
      )}
    </div>
  )
}
